import { useEffect } from 'react'

import { Bases } from '../components/Bases'
import { SymbolCrest } from '../components/SymbolCrest'
import { Symbols } from './Symbols'
import { markSymbolSeen, useSymbols } from './symbolsData'
import './symbols.css'

/**
 * Одна сущность в трёх видах: светлая сторона, перегруз и что с ней сейчас.
 * Три блока, а не один текст: символ не «хороший» и не «плохой», и человек
 * должен видеть обе стороны рядом, иначе останется только лестная.
 */
export function SymbolScreen({ id }: { id: string }) {
  const { data, error } = useSymbols()
  const symbol = data?.symbols.find((item) => item.id === id) ?? null

  useEffect(() => {
    if (symbol) markSymbolSeen(symbol.id)
  }, [symbol])

  if (error) return <div className="state">{error}</div>
  if (!data) return <div className="state">Открываем символ…</div>
  // Ссылка из ленты может пережить смену периода: показываем колоду, а не тупик.
  if (!symbol) return <Symbols notFound />

  return (
    <div className="screen symbol">
      <div className="topbar">
        <div className="brand">АТЛАС</div>
        <div className="topnote">{symbol.kind === 'natal' ? 'врождённое' : 'сейчас в периоде'}</div>
      </div>

      <div className="symbol-hero">
        <SymbolCrest symbol={symbol} size={104} />
        <h1 className="display">{symbol.title}</h1>
        <div className="sub">{symbol.subtitle}</div>
      </div>

      <div className="card side-card">
        <div className="lbl" style={{ color: symbol.color }}>
          Светлая сторона
        </div>
        <p>{symbol.sides.light}</p>
      </div>

      <div className="card side-card">
        <div className="lbl" style={{ color: 'var(--bordo)' }}>
          Перегруз
        </div>
        <p>{symbol.sides.overload}</p>
      </div>

      {symbol.sides.now ? (
        <div className="card side-card">
          <div className="lbl" style={{ color: 'var(--gold)' }}>
            Сейчас
          </div>
          <p>{symbol.sides.now}</p>
        </div>
      ) : (
        <div className="card side-card side-card-off">
          <div className="lbl">Сейчас</div>
          <p>Сейчас: не в фокусе периода</p>
        </div>
      )}

      <Bases items={symbol.bases} />
    </div>
  )
}
